import { 
	call, 
	put, 
	takeEvery 
} from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";

export default function* versionsUpdates(action: ActionInterface): any {
  try {
    const res = yield call(Http.get, "versions/updates?offset=0&limit=10");

    yield put({
      type: Constants.GLOBAL_VERSIONS_UPDATE_LIST_SUCCESS
    });

		if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, res.data);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchVersionsUpdates() {
  yield takeEvery(Constants.GLOBAL_VERSIONS_UPDATE_LIST, versionsUpdates);
}
